export default "__VITE_ASSET__DBgOPSh___"